namespace Ir.Components.User.UserProfileEditor {
    interface IViewModel {
        gridOptions: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;

        popupOptions: DevExpress.ui.dxPopup.Properties;
        popupComponent: DevExpress.ui.dxPopup;

        popupGridOptions: DevExpress.ui.dxDataGrid.Properties;
        popupGridComponent: DevExpress.ui.dxDataGrid;

        profiles: Array<UserProfile>;
        groups: Array<any>;
        permissionsType: Array<any>;
    }
    interface IParams {
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        load(self, params);

        let store = new DevExpress.data.CustomStore({
            key: "id",
            load() {
                return self.profiles;
            },
            insert(values) {
                let d = $.Deferred();

                let userProfile = values;
                userProfile.save(true, function (result) {
                    userProfile.id = result.id;
                    userProfile.externalId = result.externalId;
                    d.resolve(userProfile);
                }, function () {
                    d.resolve(false);
                });

                self.profiles.push(userProfile);

                return d.promise();
            },
            update(key, values) {
                let d = $.Deferred();

                let userProfile = self.profiles.find(x => x.id === key);
                if (userProfile) {
                    Object.assign(userProfile, values);
                    userProfile.save(false, function () {
                        d.resolve();
                    }, function () {
                        d.resolve(false);
                    });
                }
                else {
                    d.resolve();
                }

                return d.promise();
            },
            remove(key) {
                let d = $.Deferred();
                let userProfile = self.profiles.find(x => x.id === key);
                if (userProfile) {
                    userProfile.delete(function (result) {
                        if (result.success) {
                            let profiles = self.profiles.filter(function (value) {
                                return value.id !== key;
                            });
                            self.profiles = profiles;
                            d.resolve();
                        }
                        else {
                            irGlobal.defaultErrorFunction("Failed to delete user profile", result.message, "");
                            d.resolve(false);
                        }
                    });
                }
                return d.promise();
            }
        });
        this.gridOptions = {
            height: "100%",
            width: "100%",
            paging: {
                enabled: false
            },
            dataSource: store,
            columns: [
                {
                    dataField: "name",
                    caption: "Name",
                    allowSorting: true,
                    sortOrder: "asc",
                    calculateSortValue(rowData) {
                        if (rowData.externalId === 1) {
                            return rowData.externalId + rowData.name;
                        }

                        return 2 + rowData.name;
                    },
                    validationRules: [{
                        message: "Name is not unique",
                        type: 'custom',
                        validationCallback(e) {
                            let valid = self.profiles.filter(x => x.name == e.value && x.id !== e.data.id).length == 0;
                            return valid;
                        }
                    }, {
                        type: "custom",
                        validationCallback(v) {
                            if (v.value === undefined || v.value === null) {
                                return false;
                            }

                            if (v.value.trim() === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Name is required"
                    }]
                },
                {
                    dataField: "config.permissionsSelected",
                    caption: "Permissions",
                    visible: false,
                    editCellTemplate(cellElement, cellInfo) {
                        let container = $("<div>");
                        let descriptionDiv = $("<div>").dxTextArea({ readOnly: true, height: 50 });
                        let textArea = descriptionDiv.dxTextArea("instance");

                        container.append($("<div>").dxDataGrid({
                            dataSource: self.permissionsType,
                            selectedRowKeys: cellInfo.data.config.permissionsSelected,
                            keyExpr: "type",
                            columns: [
                                { dataField: "type", visible: false },
                                "name",
                                {
                                    dataField: 'groupId',
                                    groupIndex: 0,
                                    groupCellTemplate(element, options) {
                                        let group = self.groups.find(x => x.groupId === options.value);
                                        element.text(group.groupName);
                                    },
                                    sortingMethod(value1, value2) {
                                        let group1 = self.groups.find(x => x.groupId === value1);
                                        let group2 = self.groups.find(x => x.groupId === value2);

                                        if (group1.groupOrder < group2.groupOrder) return -1;
                                        if (group1.groupOrder > group2.groupOrder) return 1;

                                        return 0;
                                    }
                                }],
                            height: 400,
                            hoverStateEnabled: true,
                            focusedRowEnabled: true,
                            showRowLines: true,
                            showColumnLines: false,
                            grouping: {
                                autoExpandAll: true,
                            },
                            paging: {
                                enabled: false
                            },
                            groupPanel: {
                                visible: false,
                            },
                            scrolling: {
                                useNative: false
                            },
                            selection: {
                                mode: 'multiple',
                                showCheckBoxesMode: "always",
                                allowSelectAll: false
                            },
                            onSelectionChanged(e) {
                                cellInfo.setValue(e.component.getSelectedRowKeys());
                            },
                            onFocusedRowChanging(e) {
                                textArea.option("value", e.rows[e.newRowIndex].data.description);
                            }
                        }));

                        container.append(descriptionDiv);
                        return container;
                    }
                },
                {
                    type: "buttons",
                    buttons: [{
                        icon: "user",
                        onClick(e) {
                            userProfileId = e.row.data.id;
                            self.popupComponent.show();
                        }
                    }, {
                        name: "edit",
                        visible(e) {
                            return e.row.data.externalId !== 1;
                        },
                    }, {
                        name: "delete",
                        visible(e) {
                            return e.row.data.externalId !== 1;
                        },
                    }]
                }
            ],
            showBorders: true,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
                useIcons: true,
                popup: {
                    title: 'User Profile',
                    showTitle: true,
                    width: 600,
                    height: 600,
                    toolbarItems: [{
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: {
                            icon: 'save',
                            stylingMode: 'contained',
                            type: 'default',
                            text: "Save",
                            onClick() {
                                self.gridComponent.saveEditData();
                            }
                        }
                    }, {
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: {
                            text: 'Cancel',
                            icon: 'remove',
                            stylingMode: 'outlined',
                            type: 'normal',
                            onClick() {
                                self.gridComponent.cancelEditData();
                            }
                        }
                    }]
                },
                form: {
                    items: [{
                        itemType: 'group',
                        colCount: 2,
                        colSpan: 2,
                        items: [
                            { dataField: 'name', colSpan: 2 },
                            { dataField: 'config.permissionsSelected', colSpan: 2, }
                        ],
                    }]
                },

            },
            toolbar: {
                items: [
                    {
                        name: "addRowButton", cssClass: "customAddRowDataGridAdmin", location: "before",
                        widget: 'dxButton',
                        options: {
                            text: 'Create User Profile'
                        },

                    },
                    { name: "searchPanel", location: "after" }
                ]
            },
            repaintChangesOnly: true,
            focusedRowEnabled: true,
            keyExpr: "id",
            focusedRowIndex: 0,
            searchPanel: {
                visible: true,
                highlightSearchText: true,
            },
            onInitialized(e) {
                self.gridComponent = e.component;
            },
            onInitNewRow(e) {
                e.data = new UserProfile(null);
                let newName = e.data.name;
                let countName = 1;
                while (self.profiles.filter(x => x.name == newName).length > 0) {
                    newName = `${e.data.name} ${countName}`;
                    countName++;
                }
                e.data.name = newName;
            },
            onRowInserted(e) {
                e.component.option("focusedRowKey", e.data.id);
            }
        };

        let userProfileId = 0;
        let usersDataSource = ko.observableArray([]);
        this.popupOptions = {
            width: 400,
            height: 600,
            showTitle: true,
            title: "Users",
            visible: false,
            dragEnabled: false,
            hideOnOutsideClick: false,
            showCloseButton: true,
            position: {
                at: "center",
                my: "center",
            },
            onInitialized(e) {
                self.popupComponent = e.component;
            },
            onShowing(e) {
                let resultVM = getUsers(userProfileId);
                usersDataSource(resultVM.users);
            },
            onHiding(e) {
                usersDataSource([]);
            }
        };

        this.popupGridOptions = {
            height: 540,
            dataSource: usersDataSource,
            columns: [
                { dataField: "id", visible: false },
                { dataField: "name", caption: "User" },
                {
                    type: 'buttons',
                    width: 50,
                    visible: loggedUser.permissions.usersGroups(),
                    buttons: [{
                        hint: 'Open user',
                        icon: 'link',
                        onClick(e) {
                            window.open(`${window.location.origin}/UserAdmin/Edit/${e.row.data.id}`, '_blank').focus();
                        }
                    }],
                }
            ],
            paging: {
                enabled: false
            },
            searchPanel: {
                visible: true
            },
            scrolling: {
                useNative: false
            },
            toolbar: {
                items: [{
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        hint: 'Refresh',
                        icon: 'refresh',
                        onClick() {
                            let resultVM = getUsers(userProfileId);
                            usersDataSource(resultVM.users);
                        }
                    }
                }]
            },
            onInitialized(e) {
                self.popupGridComponent = e.component;
            },
            onRowPrepared(e) {
                if (e.data && !(e.data as UserOfProfileVM).active) {
                    e.rowElement.addClass("ir-inactive");
                }
            }
        };
    }

    function load(self: IViewModel, params: IParams) {
        self.profiles = [];
        let o = {
            url: urlConfigs.userProfiles + "/GetUserProfiles",
            data: null,
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result: any, e) {
            self.profiles = createInstances(UserProfile, result.profiles ?? []);
            self.groups = result.groups;
            self.permissionsType = result.permissionsType;
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get user profiles";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    function getUsers(userProfileId: number) {
        let resultVM: UsersOfProfileResultVM = null;
        let o = {
            url: urlConfigs.userProfiles + "/GetUsers",
            data: { id: userProfileId },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data: UsersOfProfileResultVM, e) {
            resultVM = data;
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get users from user profiles";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return resultVM;
    }
}